export default __webpack_public_path__ + "static/media/know-regd-publisher.dec55084.webp";